import { NotificationService } from '../components/notification.toast/notification.service';
import { T } from '../i18n/index';
import { LicenseService } from '../services/license.service';
import { AnalyticsService } from './analytics.service';
import { CollectionService } from './collection.service';
import { ConfigService } from './config.service';
import { DashboardService } from './dashboard.service';
import { DateTimeService } from './date.time.service';
import { DepartmentService } from './department.service';
import { DownloadService } from './download.service';
import { DrawStateService } from './draw.state.service';

import { FocusAwayService } from './focus.away.service';
import { FormService } from './form.service';
import { GeocoderService } from './geocoder.service';
import { IkeRestService } from './ike.rest.service';
import { InputService } from './input/input.service';
import { Logger as LogServiceLogger, LogService } from './log.service';
import { MapService } from './map.service';
import { MeasurementService } from './measurement.service';
import { MultiListSearchService } from './multi.list.search.service';
import { LocalStorage as ObservableLocalStorage } from './observable.storage';
import { RenderService } from './render.service';
import { RouteService } from './route.service';
import { SearchOrgService } from './search.org.service';
import { SearchService } from './search.service';
import { SSOService } from './sso.service';
import { StreetviewService } from './streetview.service';
import { SubFormLinkService } from './subform.link/subform.link.service';
import { TagService } from './tag.service';
import { TokenService } from './token.service';
import { UserProfileService } from './user.profile.service';
import { SSOUserService } from './user.service';
import { UserSettingsService } from './user.settings.service';
import { WindowService } from './window.service';

export function handleGenericError(e: Error) {
	NotificationService.error({
		key: T.ERROR_GENERAL,
	});
	return null;
}

export interface IkeClientService {
	/** Priority to call init on  Lowest number is highest priorty */
	__priority: number;
	init?(): void | Promise<void>;
}

class ServiceRegistry {
	constructor(
		public Analytics = new AnalyticsService(),
		public Collection = new CollectionService(),
		public Config = new ConfigService(),
		public SSO = new SSOService(),
		public DateTime = new DateTimeService(),
		public Department = new DepartmentService(LogServiceLogger),
		public Download = new DownloadService(),
		public DrawState = new DrawStateService(LogServiceLogger),
		public FocusAway = new FocusAwayService(),
		public Form = new FormService(),
		public Geocoder = new GeocoderService(),
		public Input = new InputService(),
		public LocalStorage = ObservableLocalStorage,
		public Log = new LogService(),
		public Map = new MapService(),
		public Measurement = new MeasurementService(),
		public Render = new RenderService(),
		public Rest = new IkeRestService(),
		public Route = new RouteService(),
		public SearchOrg = new SearchOrgService(),
		public Dashboard = new DashboardService(),
		public MultiListSearch = new MultiListSearchService(),
		public Search = new SearchService(),
		public Streetview = new StreetviewService(),
		public SubFormLink = new SubFormLinkService(),
		public Tag = new TagService(),
		public Token = new TokenService(),
		public User = new SSOUserService(),
		public UserProfile = new UserProfileService(LogServiceLogger),
		public UserSettings = new UserSettingsService(),
		public Window = new WindowService(),
		public License = new LicenseService()
	) {}

	async bindServices() {
		const allServices: IkeClientService[] = Object.values(this).sort((a, b) => a.__priority - b.__priority);
		for await (const service of allServices) {
			if (typeof service.init === 'function') {
				const initiator = service.init();

				if (initiator && typeof initiator.then === 'function') {
					await initiator;
				}
			}
		}
	}
}

let _services: ServiceRegistry | null = null;
export let Services: ServiceRegistry;

export function initServices(): ServiceRegistry {
	if (!_services) {
		_services = new ServiceRegistry();
		Services = _services;
	}
	return _services;
}

// Re-export Logger directly from log.service (no dependency on Services singleton).
export { Logger } from './log.service';
